// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  typingId: __t.u64().primaryKey().name("typing_id"),
  conversationId: __t.u64().name("conversation_id"),
  userIdentity: __t.identity().name("user_identity"),
  startedAt: __t.timestamp().name("started_at"),
});
